import { AnalysisDriverType } from "../types/types";

/**
 * Formats a metric value based on the analysis mode.
 * @param value - The value to format (number, string, or undefined).
 * @param mode - The analysis mode (e.g., "PERCENTAGE" or "COLUMN").
 * @param options - Optional formatting options.
 * @returns Formatted string.
 */
export const formatMetric = (
  value: number | string | undefined,
  mode: AnalysisDriverType,
  options?: { noDecimals?: boolean }
) => {
  if (value === undefined || value === null) return "";

  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return value.toString();

  const decimals = options?.noDecimals ? 0 : 2;

  if (mode === "PERCENTAGE") {
    return `${num.toFixed(decimals)}%`;
  }

  return num.toFixed(decimals);
};
